/* Gravity3D — lecteur 3D intégrable en deux lignes.
 *
 *   <script src="https://view.withmoonlabs.com/v/0/gravity3d-viewer.js" defer></script>
 *   <gravity3d-viewer experience="google/pixel-11" product="p11pro"></gravity3d-viewer>
 *
 * Attributs propres à Gravity3D :
 *   experience   org/expérience publiée (charge p/<org>/<exp>/<distribution>.json)
 *   distribution enseigne (« main » = page de la marque, par défaut)
 *   lang         langue (si l'option Multi-langues est active ; sinon la langue par défaut)
 *   base         adresse du serveur public (par défaut : celle d'où vient ce script)
 * Les attributs historiques de xp-viewer (config, product, variant, mode) restent valables,
 * et la balise <xp-viewer> continue de fonctionner.
 */
import { XPViewer, GENERATORS } from './viewer.js';
export { XPViewer, GENERATORS };
export { buildPhone } from './generators/phone.js';
export const VERSION = '0.2.0';

// Dossier racine du serveur public : …/v/<version>/gravity3d-viewer.js → …/
const SCRIPT = typeof document !== 'undefined' && document.currentScript ? document.currentScript.src : '';
const DEFAULT_BASE = SCRIPT ? new URL('../../', SCRIPT).href : '';

const clean = (s) => String(s || '').toLowerCase().replace(/[^a-z0-9-]/g, '');

export class Gravity3DViewer extends XPViewer {
  static get observedAttributes() { return [...super.observedAttributes, 'experience', 'distribution', 'lang', 'base']; }

  attributeChangedCallback(name, old, val) {
    if (['experience', 'distribution', 'lang', 'base'].includes(name)) {
      clearTimeout(this._expT); this._expT = setTimeout(() => this._loadExperience());
      return;
    }
    super.attributeChangedCallback(name, old, val);
  }

  /** URL du fichier publié pour cette expérience / enseigne / langue. */
  publishedUrl() {
    const [org, exp] = (this.getAttribute('experience') || '').split('/').map(clean);
    if (!org || !exp) return null;
    const base = new URL(this.getAttribute('base') || DEFAULT_BASE || '/', location.href).href.replace(/\/?$/, '/');
    const dist = clean(this.getAttribute('distribution')) || 'main';
    const lang = clean(this.getAttribute('lang') || (navigator.language || '').slice(0, 2));
    return { url: `${base}p/${org}/${exp}/${dist}.json`, lang, base: `${base}p/${org}/${exp}/` };
  }

  async _loadExperience() {
    const t = this.publishedUrl(); if (!t) return;
    try {
      const index = await fetch(t.url, { mode: 'cors' }).then((r) => { if (!r.ok) throw new Error(`${r.status} ${t.url}`); return r.json(); });
      // Le fichier principal liste les langues publiées ; on prend celle du visiteur si elle existe.
      let cfg = index;
      const alt = index.meta?.languages?.[t.lang];
      if (alt && alt !== t.url) cfg = await fetch(new URL(alt, t.url)).then((r) => r.json());
      cfg.__base = t.base;
      this.config = cfg;
      this._emit('gravity3d-loaded', { meta: cfg.meta });
    } catch (e) { this._error(e); }
  }

  /** Lien d'achat du produit / coloris affiché (option « Bouton d'achat »). */
  buyUrl() {
    const c = this.cfg?.meta?.cta; if (!c || !this.product) return null;
    const v = this.product.variants?.[this.variantIndex];
    return (v && c.urls?.[`${this.product.id}/${v.id}`]) || c.urls?.[this.product.id] || c.url || null;
  }
}

if (typeof customElements !== 'undefined' && !customElements.get('gravity3d-viewer')) customElements.define('gravity3d-viewer', Gravity3DViewer);
